module.exports = __webpack_public_path__ + "static/media/gryphon-text.5e1bb388.svg";